<template>
    <Listing api="/branchs" :title="title" :fields="fields" :filters-schema="filtersSchema" :filters="filters" @extra-data="onExtraData" />
</template>

<script>
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Listing from "@/components/listing";

    export default {
        page: {
            title: "Liste des filières",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            PageHeader,
            Listing
        },
        data: () => ({
            title: "Liste des filières",
            fields: ["code", "nom", "niveau"],
            filters: {},
            filtersData: {},
            selectedYear: {},
            loading: false
        }),
        methods: {
            onExtraData(data) {
                this.filtersData = data;
            },
            clearFilters() {
                this.filters = {};
            }
        },
        computed: {
            filtersSchema() {
                return {
                    groups: [
                        {
                            styleClasses: "row align-items-end",
                            fields: [
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Code",
                                    model: "code",
                                    debounce: 500,
                                    styleClasses: "col font-size-12 text-muted"
                                },
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Nom",
                                    model: "nom",
                                    debounce: 500,
                                    styleClasses: "col font-size-12 text-muted"
                                },
                                {
                                    type: "multiselect",
                                    label: "Niveau",
                                    model: "niveau",
                                    styleClasses: "col font-size-12 text-muted",
                                    values: this.filtersData.categories || []
                                },
                                {
                                    type: "submit",
                                    buttonText: "Effacer",
                                    styleClasses: "col-auto",
                                    attributes: {
                                        class: "btn btn-light mb-1"
                                    },
                                    onSubmit: this.clearFilters
                                }
                            ]
                        }
                    ]
                };
            }
        }
    };
</script>
